import { Map } from "immutable";

import { STATUS } from "../../utils/constants";

import {
  INIT_INSTANCE,
  REMOVE_INSTANCE,
  RESET,
  SET_IS_FETCHING_STATUS,
  SET_IS_SEARCH_RESULT_OPEN,
  SET_PRODUCTS,
  SET_SEARCH,
} from "./add-product-to-kit-inline.actionTypes";

const instanceInitialState = {
  isFetchingStatus: STATUS.IDLE,
  products: [],
  isSearchResultOpen: false,
  search: "",
};

const initialState = {
  instances: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_INSTANCE: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: instanceInitialState,
        },
      };
    }

    case REMOVE_INSTANCE: {
      const newInstances = { ...state.instances };
      delete newInstances[action.payload.instanceId];
      return {
        ...state,
        instances: newInstances,
      };
    }

    case SET_IS_FETCHING_STATUS: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...state.instances[action.payload.instanceId],
            isFetchingStatus: action.payload.status,
          },
        },
      };
    }

    case SET_PRODUCTS: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...state.instances[action.payload.instanceId],
            products: action.payload.products,
          },
        },
      };
    }

    case SET_IS_SEARCH_RESULT_OPEN: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...state.instances[action.payload.instanceId],
            isSearchResultOpen: action.payload.isOpen,
          },
        },
      };
    }

    case SET_SEARCH: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...state.instances[action.payload.instanceId],
            search: action.payload.search,
          },
        },
      };
    }

    case RESET: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: instanceInitialState,
        },
      };
    }

    default:
      return state;
  }
};
